import { render } from "./MobileTemplate.vue?vue&type=template&id=b1f45a4a&scoped=true&ts=true"
import script from "./MobileTemplate.vue?vue&type=script&lang=ts"
export * from "./MobileTemplate.vue?vue&type=script&lang=ts"

import "./MobileTemplate.vue?vue&type=style&index=0&id=b1f45a4a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f45a4a"]])

export default __exports__